(function () {
  var finalCta = document.querySelector('.flp-final-button.flp-cta--spectacle');
  if (!finalCta) return;

  // Translate the complete label before splitting it into animated letters.
  // Individual letters cannot be translated by the shared text-node walker.
  function syncLabel() {
    document.querySelectorAll('.flp-cta-wave').forEach(function (wave) {
      var english = document.documentElement.getAttribute('lang').slice(0, 2) === 'en';
      var label = english ? 'Create your bouquet' : 'Crea il tuo bouquet';
      wave.setAttribute('data-native-i18n-skip', '1');
      wave.replaceChildren();
      var index = 0;
      label.split(' ').forEach(function (word) {
        var group = document.createElement('span');
        group.className = 'flp-cta-wave__word';
        Array.from(word).forEach(function (letter) {
          var char = document.createElement('span');
          char.className = 'flp-cta-wave__char';
          char.style.setProperty('--flp-wave-index', index++);
          char.textContent = letter;
          group.appendChild(char);
        });
        wave.appendChild(group);
        wave.appendChild(document.createTextNode(' '));
      });
    });
  }
  syncLabel();
  window.addEventListener('florame:native-language-change', syncLabel);

  if (!('IntersectionObserver' in window)) {
    finalCta.classList.add('is-flp-cta-in-view');
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      finalCta.classList.toggle('is-flp-cta-in-view', entry.isIntersecting && entry.intersectionRatio >= 0.35);
    });
  }, { threshold: [0, 0.35, 0.7] });

  observer.observe(finalCta);
})();
